export const projects = "/projects"
export const projectDetail = `:projectId`
export const getProjectsDetailsUrl = (id: string) => `${projects}/${id}`
